import { useState, useCallback, useRef } from 'react';
import documentDSLServices from '../../redux/services/documentDSL.service';

const usePollingStatuses = ({ targetStatus, onFinish }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const isRunningRef = useRef(false);

  const trackProgress = useCallback(
    async (documentIds) => {
      if (isRunningRef.current) {
        return;
      }
      if (!documentIds || documentIds.length === 0) {
        setIsLoading(false);
        return;
      }

      isRunningRef.current = true;
      let itemsToPoll = [...documentIds];
      setCompletedCount(0);
      setProgress(0);
      const completedItems = new Set();
      // disabling eslint error as awaiting inside this loop is indeed intended
      /* eslint-disable no-await-in-loop */
      while (completedItems.size < documentIds.length) {
        setIsLoading(true);
        const promises = itemsToPoll.map((id) => documentDSLServices.fetchDocumentStatus(id));
        const results = await Promise.all(promises);
        const remainingItems = [];
        for (const result of results) {
          const { data } = result.data;
          if (data.status === targetStatus) {
            completedItems.add(data.id);
            setCompletedCount(completedItems.size);
            setProgress((completedItems.size / documentIds.length) * 100);
          } else {
            remainingItems.push(data.id);
          }
        }
        itemsToPoll = remainingItems;
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      /* eslint-enable no-await-in-loop */
      onFinish();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(false);
      setProgress(0);
      setCompletedCount(0);
      isRunningRef.current = false;
    },
    [targetStatus, onFinish]
  );

  return {
    isLoading,
    progress,
    completedCount,
    trackProgress,
  };
};
export default usePollingStatuses;
